import { Dialog, Tab, Transition } from "@headlessui/react";
import * as htmlToImage from "html-to-image";
import moment from "moment";
import {
  ChangeEvent,
  Fragment,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { toast } from "react-toastify";
import discount from "../../assets/images/icon_invoice/discount.svg";
import invoice from "../../assets/images/icon_invoice/invoice.svg";
import invoiceCredit from "../../assets/images/icon_invoice/InvoiceCredit.svg";
import invoiceNonCredit from "../../assets/images/icon_invoice/InvoiceNonCredit.svg";
import invoiceCreditPartial from "../../assets/images/icon_invoice/InvoiceCreditPartial.svg";
import autoDebetPartial from "../../assets/images/icon_invoice/icon_autodebet/perdetail.svg";
import autoDebetNonCredit from "../../assets/images/icon_invoice/icon_autodebet/noncredit.svg";
import autoDebetCredit from "../../assets/images/icon_invoice/icon_autodebet/credit.svg";
import paymentSuccess from "../../assets/images/icon_invoice/payment-success.svg";
import { isDarkColor } from "../../config/DarkColorChecker";
import { formatCurrency, numberWithCommas } from "../../config/global";
import { downloadBase64 } from "../../config/iosBridge";
import { setLoading } from "../../core/feature/config/configSlice";
import { useAppSelector } from "../../core/feature/hooks";
import { setLanguage } from "../../core/feature/language/languageSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import CustomApp from "../../core/models/customApp";
import User from "../../core/models/user";
import { credentialCheck, getCustomApps } from "../../core/service/api";
import { getBalance } from "../../core/service/api_balance";
import {
  downloadSummary,
  getAllInvoice,
  getAllInvoiceHistory,
  getAllInvoicePaid,
  getAllInvoiceSummary,
  getInvoiceTags,
  invoicePayment,
} from "../../core/service/api_invoice";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import { i18n } from "../../translations/i18n";
import TabsMobile from "../__template/TabsMobileComponent";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { match } from "assert";
import Select from "react-select";
import { ArrowUpRightFromCircle } from "lucide-react";

const INVOICE_ACTIVE_SESSION_KEY = "invoice_active_tab";
const DEFAULT_INVOICE_ACTIVE_TAB = "all";
const INVOICE_ACTIVE_TAB_KEYS = ["all", "history", "summary"];

const getInitialInvoiceActiveTabIndex = () => {
  try {
    const storedActive = window.sessionStorage.getItem(
      INVOICE_ACTIVE_SESSION_KEY,
    );
    const tabIndex = INVOICE_ACTIVE_TAB_KEYS.indexOf(
      storedActive || DEFAULT_INVOICE_ACTIVE_TAB,
    );

    if (tabIndex !== -1) {
      return tabIndex;
    }
  } catch (error) {}

  return 0;
};

const ComponentInvoice = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  const [isToken, setIsToken] = useState<any>(false);

  const user: User = useAppSelector((state) => state.user.user);
  const balance: number = useAppSelector((state) => state.balance.balance);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp,
  );
  const [invoices, setInvoices] = useState<any>([]);
  const [invoicePaid, setInvoicePaid] = useState<any>([]);
  const [invoiceSummary, setInvoiceSummary] = useState<any>([]);
  const [detailPaymentSuccess, setDetailPaymentSuccess] = useState<any>([]);
  const [invoiceDetail, setInvoiceDetail] = useState<any>([]);
  const [invoiceDetailHistory, setInvoiceDetailHistory] = useState<any>([]);
  const [dataTempHistory, setDataTempHistory] = useState<any>([]);
  const [openDetailInvoice, setOpenDetailInvoice] = useState(false);
  const [openSorting, setOpenSorting] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [openPaymentSuccessInvoice, setOpenPaymentSuccessInvoice] =
    useState(false);
  const [openDetailHistory, setOpenDetailHistory] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isShowMore, setIsShowMore] = useState(false);
  const [showDescription, setShowDescription] = useState(true);
  const inputAmount = useRef<HTMLInputElement>(null);
  const [amount, setAmount] = useState("");
  const [page, setPage] = useState(0);
  const [indexes, setIndexes] = useState(0);
  const [size, setSize] = useState(10);
  const [activeTab, setActiveTab] = useState(getInitialInvoiceActiveTabIndex);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const ref = useRef<HTMLDivElement>(null);
  let [isOpen, setIsOpen] = useState(false);
  const ref2 = useRef<HTMLDivElement>(null);
  var invoicea = `${t("INVOICE.title")}`;
  var history = `${t("INVOICE.history")}`;
  var summary = `${t("INVOICE.summary")}`;
  var placeholder = `${t("INVOICE.placeholder")}`;
  const [sortBy, setSortBy] = useState("invoiceDate_Desc");
  const [minimumPayment, setMinimumPayment] = useState(0);
  const [openInformation, setOpenInformation] = useState(false);
  let [categories] = useState({
    [invoicea]: [],
    [history]: [],
    [summary]: [],
  });

  const callerIdentities = user?.accounts?.[0]?.callerIdentities ?? [];
  const singleCallerIdentityId =
    callerIdentities.length === 1
      ? String(callerIdentities[0]?.id ?? callerIdentities[0]?.callerId ?? "")
      : "";
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedStudentId, setSelectedStudentId] = useState(
    singleCallerIdentityId,
  );
  const [draftTags, setDraftTags] = useState<string[]>([]);
  const [draftStudentId, setDraftStudentId] = useState(singleCallerIdentityId);
  const [filterTagOptions, setFilterTagOptions] = useState<string[]>([]);
  const tagSelectOptions = filterTagOptions.map((tag) => ({
    label: tag,
    value: tag,
  }));
  const [filterInvoiceName, setFilterInvoiceName] = useState<string>("");
  const tagSelectStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: 48,
      borderRadius: 12,
      borderColor: "#cbd5e1",
      boxShadow: "none",
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 1400,
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 9999,
    }),
    menuList: (base: any) => ({
      ...base,
      maxHeight: 240,
      overflowY: "auto",
    }),
    multiValue: (base: any) => ({
      ...base,
      backgroundColor: customApp?.app_accent_color,
      color: isDarkColor(customApp?.app_accent_color) ? "#ffffff" : "#000000",
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      color: isDarkColor(customApp?.app_accent_color) ? "#ffffff" : "#000000",
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      color: isDarkColor(customApp?.app_accent_color) ? "#ffffff" : "#000000",
    }),
  };

  const sortingOptions = [
    { label: t("SORTING.invoiceDateDesc"), value: "invoiceDate_Desc" },
    { label: t("SORTING.invoiceDateAsc"), value: "invoiceDate_Asc" },
    { label: t("SORTING.dueDateAsc"), value: "dueDate_Asc" },
    { label: t("SORTING.dueDateDesc"), value: "dueDate_Desc" },
    { label: t("SORTING.amountAsc"), value: "amount_Asc" },
    { label: t("SORTING.amountDesc"), value: "amount_Desc" },
  ];

  const shareButton = useRef<HTMLButtonElement>(null);
  const [url, setUrl] = useState<string>("none"); // Unfortunately, we have to have a dummy string here, or FacebookShareButton will blow up.

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  const paymentAction = async () => {
    setOpenDetailHistory(false);
    setOpenDetailInvoice(false);
    setIsOpen(true);
  };
  const closeAction = async () => {
    setIsOpen(false);
  };
  const download = async () => {
    downloadSummary()
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `summary_invoice_${moment().format("ll")}.xls`,
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {});
  };

  const getIconInvoice = (item: any) => {
    const { automaticPayment, partialMethod, creditDetailPayment } = item;

    // autodebet
    if (automaticPayment) {
      if (!partialMethod) return autoDebetNonCredit;
      return !creditDetailPayment ? autoDebetCredit : autoDebetPartial;
    }

    // maunal payment
    if (!partialMethod) return invoiceNonCredit;
    return !creditDetailPayment ? invoiceCredit : invoiceCreditPartial;
  };

  const handleSortChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPage(0);
    const sortData = e.target.value;
    setSortBy(sortData);
  };

  const resolveStudentId = (identityId = selectedStudentId) =>
    identityId || singleCallerIdentityId;

  const getSelectedCallerIds = (identityId = selectedStudentId) => {
    const resolvedIdentityId = resolveStudentId(identityId);
    const selectedIdentity = callerIdentities.find((identity: any) => {
      const identityValue = identity?.id ?? identity?.callerId ?? "";
      return String(identityValue) === String(resolvedIdentityId);
    });

    return selectedIdentity?.callerId ? [selectedIdentity.callerId] : [];
  };
  const getInvoice = async () => {
    dispatch(setLoading(true));
    const sort = sortBy.split("_");
    getAllInvoice(
      size,
      page,
      sort[0],
      sort[1],
      "",
      "",
      selectedTags,
      getSelectedCallerIds(),
    )
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoices(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const addMoreInvoice = async () => {
    setPage(page + 1);
    dispatch(setLoading(true));
    const sort = sortBy.split("_");
    getAllInvoice(
      size,
      page + 1,
      sort[0],
      sort[1],
      "",
      "",
      selectedTags,
      getSelectedCallerIds(),
    )
      .then((res) => {
        dispatch(setLoading(false));

        setInvoices(invoices.concat(res.data.content));
        console.log(res);
      })
      .catch((err) => {
        console.log(err);

        dispatch(setLoading(false));
      });
  };

  const getInvoicePaid = async () => {
    dispatch(setLoading(true));
    getAllInvoicePaid(10, 0, "Desc", "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoicePaid(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };
  // const currPaidAmount = (history, detail) => {

  // }
  const mappedData = (invoices: any[]) => {
    return invoices.map((inv: any) => {
      const newDetail = inv.detail.map((d: any) => {
        const match = inv.reference.find((ref: any) => ref.detailId === d.id);
        return {
          ...d,
          transactionAmount: match ? match.amount : 0,
        };
      });
      return {
        ...inv,
        detail: newDetail,
      };
    });
  };

  interface InvoiceHistory {
    id: string;
    invoiceMasterId: string;
    transactionId: string;
    paymentDate: string;
    amount: number;
    paidAmount: number;
    [key: string]: any; // Untuk field lainnya
  }

  const addMoreInvoicePaid = async () => {
    setPage(page + 1);
    console.log("asdasd");

    dispatch(setLoading(true));
    getAllInvoicePaid(size, page + 1, "Desc", "", "")
      .then((res) => {
        console.log(res.data);

        setInvoicePaid(invoicePaid.concat(res.data.content));
        dispatch(setLoading(false));
        console.log(res.data.content);
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };
  const getInvoiceSummary = async () => {
    dispatch(setLoading(true));
    getAllInvoiceSummary(size, 0, "Desc", "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoiceSummary(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const addMoreInvoiceSummary = async (type: String) => {
    dispatch(setLoading(true));

    if (type == "prev") {
      setPage(page - 1);
      setIndexes(indexes - 10);
      getAllInvoiceSummary(size, page - 1, "Desc", "", "")
        .then((res) => {
          dispatch(setLoading(false));
          setInvoiceSummary(res.data.content);
          console.log(res.data);
        })
        .catch((err) => {
          dispatch(setLoading(false));
        });
    } else {
      setPage(page + 1);
      setIndexes(indexes + 10);
      getAllInvoiceSummary(size, page + 1, "Desc", "", "")
        .then((res) => {
          dispatch(setLoading(false));
          setInvoiceSummary(res.data.content);
          console.log(res.data);
        })
        .catch((err) => {
          dispatch(setLoading(false));
        });
    }
  };

  const currentSizeInvoice = useMemo(() => {
    const a = invoices.length;
    const b = a / (page + 1);
    console.log("b", a, b);

    return b;
  }, [invoices]);

  const currentSizeInvoicePaid = useMemo(() => {
    const a = invoicePaid.length;
    const b = a / (page + 1);
    console.log("b", a, b);

    return b;
  }, [invoicePaid]);

  const currentSizeInvoiceSummary = useMemo(() => {
    const a = invoiceSummary.length;
    return a;
  }, [invoiceSummary]);

  function onDismissDetailInvoice() {
    setOpenDetailInvoice(false);
  }

  function onDismissDetailHistory() {
    setOpenDetailHistory(false);
  }

  function onDismissPaymentSuccessInvoice() {
    window.scrollTo(0, 0);
    setOpenPaymentSuccessInvoice(false);
  }

  function onDismissSorting() {
    setOpenSorting(false);
  }

  function onDismissFilter() {
    setOpenFilter(false);
  }

  const onDismissInformation = () => {
    setOpenInformation(false);
  };

  const openSheetDetailInvoice = async (data: any) => {
    setIsShowMore(false);
    setOpenDetailInvoice(true);
    console.log(data);
    setAmount("");
    setInvoiceDetail(data);
    if (data?.partialMethod == true) {
      if (data?.amount - data?.paidAmount <= 10000) {
        setAmount(String(data?.amount - data?.paidAmount));
        setIsActive(false);
      } else {
        setIsActive(true);
      }
    } else {
      setIsActive(false);
    }
  };
  const openSheetDetailHistory = async (data: any) => {
    // navigate("/invoice/history/detail", { state: { data: data } });
    // return;

    console.log("DATA:", data);
    const mappedHistory = data.history?.reference?.map((ref: any) => {
      return {
        ...ref,
        detail: data.detail.find((d: any) => d.id === ref.detailId),
      };
    });

    console.log("getAllInvoicePaid", mappedHistory);

    setOpenDetailHistory(true);
    setInvoiceDetailHistory(data);
    // setDataTempHistory(mappedHistory);
    //mapped

    // const mappedData = (invoices: any[]) => {
    //   return invoices.map((inv: any) => {
    //     const newDetail = inv.detail.map((d: any) => {
    //       const match = inv.reference.find((ref: any) => ref.detailId === d.id);
    //       return {
    //         ...d,
    //         transactionAmount: match ? match.amount : 0,
    //       };
    //     });
    //     return {
    //       ...inv,
    //       detail: newDetail,
    //     };
    //   });
    // };
    const mappedDetail = (detail: any[], reference: any[]) => {
      return detail.map((d: any) => {
        const match = reference.find((ref: any) => ref.detailId === d.id);
        console.log("MATCH: ", data);

        return {
          ...d,
          transactionAmount: match ? match.amount : 0,
        };
      });
    };

    setDataTempHistory(
      data.history.map((h: any) => {
        return {
          dateTime: h.dateTime,
          data: {
            ...h,
            invoiceId: data.id,
            creditDetailPayment: data.creditDetailPayment,
            partialMethod: data.partialMethod,
            title: data.title,
            dueDate: data.dueDate,
            invoiceDate: data.invoiceDate,
            paymentDate: h.dateTime,
            detail: mappedDetail(data.detail, h.reference),
            callerName: data.callerName,
            callerId: data.callerId,
          },
          // Kita map array reference untuk menggabungkan data detail asli dengan data di reference
          detail: h.reference.map((ref: any) => {
            // Cari data detail yang ID-nya cocok dengan detailId di history
            const detailInfo = data.detail.find(
              (d: any) => d.id === ref.detailId,
            );

            // Jika ditemukan, gabungkan data detail asli dengan amount dari history
            // Jika tidak ditemukan, return data reference saja atau handle sesuai kebutuhan
            return detailInfo
              ? { ...detailInfo, transactionAmount: ref.amount }
              : {
                  detailId: ref.detailId,
                  amount: ref.amount,
                  note: "Detail not found",
                };
          }),
        };
      }),
    );
  };

  const openSortingMenu = () => {
    setOpenSorting(true);
  };

  const openFilterMenu = () => {
    setDraftTags(selectedTags);
    setDraftStudentId(resolveStudentId());
    setOpenFilter(true);
  };

  const applyFilters = () => {
    const nextStudentId = resolveStudentId(draftStudentId);

    setSelectedTags(draftTags);
    setSelectedStudentId(nextStudentId);
    setPage(0);
    dispatch(setLoading(true));
    const sort = sortBy.split("_");
    getAllInvoice(
      size,
      0,
      sort[0],
      sort[1],
      "",
      "",
      draftTags,
      getSelectedCallerIds(nextStudentId),
      filterInvoiceName,
    )
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoices(res.data.content);
        setOpenFilter(false);
      })
      .catch(() => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const resetFilters = () => {
    const nextStudentId = singleCallerIdentityId;

    setDraftTags([]);
    setDraftStudentId(nextStudentId);
    setSelectedTags([]);
    setSelectedStudentId(nextStudentId);
    setPage(0);
    dispatch(setLoading(true));
    const sort = sortBy.split("_");
    getAllInvoice(
      size,
      0,
      sort[0],
      sort[1],
      "",
      "",
      [],
      getSelectedCallerIds(nextStudentId),
    )
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoices(res.data.content);
        setOpenFilter(false);
      })
      .catch(() => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const paymentInvoice = async (data: any) => {
    onDismissDetailInvoice();
    var unpaidAmount = data.amount - data.paidAmount;

    var tempAmount;

    if (data.partialMethod == true) {
      if (parseInt(amount) > unpaidAmount)
        return toast.warning(
          t("INVOICE.amountNotValid") + formatCurrency(unpaidAmount),
        );

      if (
        unpaidAmount - parseInt(amount) < minimumPayment &&
        unpaidAmount > minimumPayment &&
        unpaidAmount != parseInt(amount)
      )
        return toast.warning(t("INVOICE.remainingPayment"));

      if (parseInt(amount) > unpaidAmount)
        return toast.warning(
          t("INVOICE.amountNotValid") + formatCurrency(unpaidAmount),
        );
      if (parseInt(amount) < minimumPayment && unpaidAmount > minimumPayment)
        return toast.warning(t("INVOICE.placeholder"));
      if (balance < parseInt(amount))
        return toast.warning(
          t("INVOICE.balanceEmpty") + formatCurrency(balance),
        );

      tempAmount = amount;
    } else {
      if (balance < unpaidAmount)
        return toast.warning(
          t("INVOICE.balanceEmpty") + formatCurrency(balance),
        );

      tempAmount = unpaidAmount.toString();
    }
    var query = {
      amount: parseInt(tempAmount),
      cash: true,
      channel: "MOBILE",
      invoiceId: data.invoiceId,
      tag: "",
    };
    console.log(query);

    console.log("jadi");

    dispatch(setLoading(true));
    invoicePayment(query)
      .then((res) => {
        setOpenDetailInvoice(false);
        setDetailPaymentSuccess(res.data);
        setOpenPaymentSuccessInvoice(true);
        setIsOpen(false);
        dispatch(setLoading(false));
        getInvoice();
        getBalance()
          .then((res) => {
            dispatch(setBalance(res.data.balance));
          })
          .catch((err) => {
            dispatch(removeUser());
            dispatch(removeBalance());
            navigate("/login", { replace: true });
          });
        gaEventTracker("Click Payment", "Payment Invoice Success");

        toast.success(t("INVOICE.success"), { autoClose: 6000 });
      })
      .catch((err: any) => {
        console.error(err);

        dispatch(setLoading(false));
      });
  };

  const onClick = async () => {
    dispatch(setLoading(true));
    setShowDescription(false);
    if (url === "none") {
      if (ref.current === null) {
        return;
      }

      htmlToImage
        .toPng(ref.current, { cacheBust: true })
        .then((dataUrl) => {
          if (localStorage.getItem("device")?.includes("ios")) {
            downloadBase64(dataUrl);
            dispatch(setLoading(false));
            setShowDescription(true);
          } else {
            var link = document.createElement("a");
            link.href = dataUrl;
            console.log(dataUrl, "sukses");
            var iframe =
              "<iframe width='100%' height='100%' src='" +
              dataUrl +
              "'></iframe>";

            const linkSource = dataUrl;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.download =
              invoiceDetail?.title + " - " + invoiceDetail?.callerName;
            downloadLink.click();

            dispatch(setLoading(false));
            setShowDescription(true);
          }
        })
        .catch((err) => {
          console.error(err);

          dispatch(setLoading(false));
          setShowDescription(true);
        });
    }
  };
  const ondownload = async () => {
    dispatch(setLoading(true));
    setShowDescription(false);
    setTimeout(() => {
      downloadImage();
    }, 1000);
  };

  const downloadImage = async () => {
    if (url === "none") {
      if (ref2.current === null) {
        return;
      }
      htmlToImage
        .toPng(ref2.current, { cacheBust: true })
        .then((dataUrl) => {
          var link = document.createElement("a");
          link.href = dataUrl;
          console.log(dataUrl, "sukses");
          var iframe =
            "<iframe width='100%' height='100%' src='" +
            dataUrl +
            "'></iframe>";

          const linkSource = dataUrl;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download =
            invoiceDetailHistory?.title +
            " - " +
            invoiceDetailHistory?.callerName;
          downloadLink.click();

          dispatch(setLoading(false));
          setShowDescription(true);
        })
        .catch((err) => {
          console.error(err);

          dispatch(setLoading(false));
          setShowDescription(true);
        });
    }
  };
  const checkIsShowDetail = (data: any) => {
    return data.showDetail || (data.partialMethod && data.creditDetailPayment);
  };
  useEffect(() => {
    try {
      if (location.pathname.split("/")[2] != undefined) {
        setIsToken(true);
        dispatch(setToken(location.pathname.split("/")[2]));
        if (location.pathname.split("/")[3] != undefined) {
          var lang = location.pathname.split("/")[3];
          i18n.changeLanguage(lang);
          dispatch(setLanguage(lang));
        }
        credentialCheck().then((resCredential) => {
          dispatch(setUser(resCredential.data.user));
          if (resCredential.data.activeCompany.customApps) {
            getCustomApps(
              resCredential.data.activeCompany.id,
              lang.toUpperCase(),
            ).then((resCustom: any) => {
              console.log(resCustom.data);
              dispatch(setCustomApp(resCustom.data));
            });
          }
        });
      }
    } catch (error) {}
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    getInvoiceTags()
      .then((res: any) => {
        setFilterTagOptions(res.data ?? []);
      })
      .catch(() => {
        setFilterTagOptions([]);
      });
  }, []);

  useEffect(() => {
    if (
      !singleCallerIdentityId ||
      selectedStudentId === singleCallerIdentityId
    ) {
      return;
    }

    setSelectedStudentId(singleCallerIdentityId);
    setDraftStudentId(singleCallerIdentityId);

    if (activeTab !== 0) {
      return;
    }

    setPage(0);
    dispatch(setLoading(true));
    const sort = sortBy.split("_");
    getAllInvoice(
      size,
      0,
      sort[0],
      sort[1],
      "",
      "",
      selectedTags,
      getSelectedCallerIds(singleCallerIdentityId),
    )
      .then((res: any) => {
        dispatch(setLoading(false));
        setInvoices(res.data.content);
      })
      .catch(() => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  }, [
    activeTab,
    dispatch,
    navigate,
    selectedStudentId,
    selectedTags,
    singleCallerIdentityId,
    size,
    sortBy,
  ]);

  useEffect(() => {
    if (url !== "none") {
      shareButton.current?.click();
      setUrl("none");
    }
  }, [url, shareButton]);

  useEffect(() => {
    if (sortBy && activeTab === 0) {
      getInvoice();
      onDismissSorting();
    }
  }, [sortBy]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (activeTab == 0) {
      setPage(0);
      getInvoice();
    } else if (activeTab == 1) {
      setPage(0);
      getInvoicePaid();
    } else {
      setPage(0);
      getInvoiceSummary();
    }
  }, [activeTab]);

  useEffect(() => {
    try {
      window.sessionStorage.setItem(
        INVOICE_ACTIVE_SESSION_KEY,
        INVOICE_ACTIVE_TAB_KEYS[activeTab] || DEFAULT_INVOICE_ACTIVE_TAB,
      );
    } catch (error) {}
  }, [activeTab]);
  useEffect(() => {}, [invoicePaid]);

  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className="bg-white px-8 pt-8 pb-3  sticky top-0">
        <TabsMobile
          name={`${t("INVOICE.title")}`}
          backUrl={"home"}
          rightComponent={
            <button onClick={() => setOpenInformation(true)} className="mr-4">
              <FontAwesomeIcon
                icon={faCircleQuestion}
                className="text-slate-500 size-5 hover:text-slate-700"
              />
            </button>
          }
        ></TabsMobile>
      </div>
      <BottomSheet
        open={openInformation}
        onDismiss={onDismissInformation}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.6,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            Keterangan
          </h1>
        }
        footer={
          <button
            onClick={onDismissInformation}
            className="p-2 bg-danger rounded-lg w-full text-white"
          >
            {" "}
            Tutup
          </button>
        }
      >
        <div className="p-4">
          <div className="flex flex-column gap-2">
            <div className="p-4 border-b border-b-silver flex items-center gap-4">
              <img src={invoiceCredit} alt="" />
              <span>Tagihan Kredit</span>
            </div>
            <div className="p-4 border-b border-b-silver flex items-center gap-4">
              <img src={invoiceCreditPartial} alt="" />
              <span>Tagihan Kredit Per Detail</span>
            </div>
            <div className="p-4 border-b border-b-silver flex items-center gap-4">
              <img src={invoiceNonCredit} alt="" />
              <span>Tagihan Non Kredit</span>
            </div>
            <div className="p-4 border-b border-b-silver flex items-center gap-4">
              <img src={autoDebetCredit} alt="" />
              <span>Tagihan Auto Debet Kredit</span>
            </div>
            <div className="p-4 border-b border-b-silver flex items-center gap-4">
              <img src={autoDebetPartial} alt="" />
              <span>Tagihan Auto Debet Kredit Per Detail</span>
            </div>
            <div className="p-4 border-b border-b-silver flex items-center gap-4">
              <img src={autoDebetNonCredit} alt="" />
              <span>Tagihan Auto Debet Non Kredit</span>
            </div>
            <i>
              <span className="text-sm">
                * Auto Debet: Tagihan terbayarkan secara otomatis ketika saldo
                mencukupi.
              </span>
            </i>
          </div>
        </div>
      </BottomSheet>
      {/* bottom detail paid invoice */}
      <BottomSheet
        open={openDetailHistory}
        onDismiss={onDismissDetailHistory}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.6,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            {invoiceDetailHistory?.title}
          </h1>
        }
        footer={
          <div className="flex flex-col gap-2 z-[1000]">
            {/* <button className="disabled:bg-psp-gray w-full bg-white shadow-lg  text-psp-primary  border-1 border-psp-primary border-solid py-2.5 text-sm font-semibold rounded-lg">
            {t("INVOICE.share")}
          </button> */}
            <button
              onClick={ondownload}
              style={{ backgroundColor: customApp?.app_accent_color }}
              className={`disabled:bg-psp-gray w-full  shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp?.app_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("INVOICE.download")}
            </button>
            <button
              onClick={() => onDismissDetailHistory()}
              style={{ backgroundColor: customApp?.app_secondary_accent_color }}
              className={`disabled:bg-psp-gray w-full shadow-lg  py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp?.app_secondary_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("OTHER.close")}
            </button>
          </div>
        }
      >
        <div className="px-4 py-2 bg-white" ref={ref2}>
          {invoiceDetailHistory?.description != "" && showDescription && (
            <div>
              {invoiceDetailHistory?.description && (
                <div
                  className="font-poppins font-normal text-sm text-psp-nav text-justify"
                  dangerouslySetInnerHTML={{
                    __html:
                      invoiceDetailHistory?.description?.length > 100 &&
                      !isShowMore
                        ? invoiceDetailHistory?.description
                            .replaceAll(/\n/g, "<br>")
                            .substring(0, 100) + "..."
                        : invoiceDetailHistory?.description.replaceAll(
                            /\n/g,
                            "<br>",
                          ),
                  }}
                ></div>
              )}

              <h1 className="font-poppins font-normal text-sm text-psp-nav text-justify">
                {invoiceDetailHistory?.description?.length > 100 && (
                  <span
                    className="text-blue-600 underline cursor-pointer"
                    onClick={() => setIsShowMore(!isShowMore)}
                  >
                    {isShowMore ? t("INVOICE.showLess") : t("INVOICE.showMore")}
                  </span>
                )}
              </h1>
            </div>
          )}
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            Data Pembayaran
          </h1>
          <div
            className={`grid grid-cols-2 gap-1 ${
              user?.name === invoiceDetailHistory?.callerName ? "hidden" : ""
            }`}
          >
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.parentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
              <div className="grow text-right">{user?.name}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.studentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
              <div className="font-poppins grow text-right">
                {invoiceDetailHistory?.callerName}
              </div>
            </div>
          </div>
          <div>
            <h1 className="font-poppins font-medium text-sm text-black my-2">
              {t("INVOICE.detailInvoice")}
            </h1>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceName")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
                <div className="grow text-right">
                  {invoiceDetailHistory?.title}
                </div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.date")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(invoiceDetailHistory?.invoiceDate).format("LL")}
                </div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.limit")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(invoiceDetailHistory?.dueDate).format("LL")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceType")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetailHistory?.partialMethod == false
                    ? t("INVOICE.cash")
                    : t("INVOICE.credit")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  Status
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetailHistory?.status == "UNPAID"
                    ? t("INVOICE.unpaid")
                    : invoiceDetailHistory?.status == "PAID"
                      ? t("INVOICE.paid")
                      : t("INVOICE.partial")}
                </div>
              </div>
            </div>
            <div hidden={!checkIsShowDetail(invoiceDetailHistory)}>
              {invoiceDetailHistory?.detail?.map((res: any) => (
                <div className="grid grid-cols-2 gap-1">
                  <div className="flex flex-row">
                    <h1 className="font-poppins font-normal text-sm text-psp-nav">
                      {res.title}
                    </h1>
                  </div>
                  <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                    <div className="grow text-right">
                      {formatCurrency(res.amount)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr />
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.total")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  invoiceDetailHistory?.amount -
                    invoiceDetailHistory?.paidAmount,
                )}
              </div>
            </div>
          </div>
          {/* <hr />
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            Rincian Pembayaran
          </h1> */}
          {/* {dataTempHistory.map((h: any) => (
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {h.title}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {formatCurrency(h.amount)}
                </div>
              </div>
            </div>
          ))} */}
          {/* <table className="w-full">
            {dataTempHistory?.map((h: any) => (
              <>
                <tr className="border-1">
                  <td
                    className="border-1 bg-gray-100 w-full"
                    colSpan={2}
                    onClick={() =>
                      navigate("/invoice/history/detail", {
                        state: { data: h.data },
                      })
                    }
                  >
                    <div className="w-full flex justify-between items-center p-2">
                      <span>{moment(h.dateTime).format("LL (HH:mm)")}</span>
                      <span className="text-xs text-right text-slate-500">
                        {" "}
                        *tap untuk detail
                      </span>
                    </div>
                  </td>
                </tr>
                {h.detail.map((d: any) => (
                  <tr className="w-full">
                    <>
                      <td className="border-1 p-1" width={"50%"}>
                        {d.title || "-"}
                      </td>
                      <td className="border-1 p-1" width={"50%"}>
                        {d.transactionAmount
                          ? formatCurrency(d.transactionAmount)
                          : "-"}
                      </td>
                    </>
                  </tr>
                ))}
                <br />
              </>
            ))}
          </table> */}
        </div>
      </BottomSheet>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeAction}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {t("INVOICE.confirm")}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      {t("INVOICE.paymentConfirm")}
                    </p>
                  </div>

                  <div className="mt-4 flex gap-2 justify-center">
                    <button
                      type="button"
                      className="active:bg-zinc-100 inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={() => closeAction()}
                    >
                      {t("OTHER.no")}
                    </button>
                    <button
                      type="button"
                      className="active:bg-psp-hover active:text-white inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={() => paymentInvoice(invoiceDetail)}
                    >
                      {t("OTHER.yes")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
      {/* bottom detail unpaid invoice */}
      <BottomSheet
        open={openDetailInvoice}
        onDismiss={onDismissDetailInvoice}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.6,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            {invoiceDetail?.title}
          </h1>
        }
        footer={
          <button
            onClick={() => {
              if (
                invoiceDetail.partialMethod &&
                invoiceDetail.creditDetailPayment &&
                invoiceDetail.detail?.reduce(
                  (a: any, b: any) => a + b.paidAmount,
                  0,
                ) != invoiceDetail.paidAmount
              )
                toast.error("Pembayaran tagihan ini tidak dapat dilakukan.");
              else paymentAction();
            }}
            disabled={isActive}
            style={{
              backgroundColor: isActive ? "gray" : customApp?.app_accent_color,
            }}
            className={`disabled:bg-psp-gray w-full  shadow-lg shadow-psp-primary py-2.5 text-sm font-semibold rounded-lg ${
              isDarkColor(customApp?.app_accent_color)
                ? "text-white"
                : "text-black"
            }`}
          >
            {t("INVOICE.pay")}
          </button>
        }
      >
        <div className="px-4 py-2">
          {invoiceDetail?.description != "" && showDescription && (
            <div>
              {invoiceDetail?.description && (
                <div
                  className="font-poppins font-normal text-sm text-psp-nav text-justify"
                  dangerouslySetInnerHTML={{
                    __html:
                      invoiceDetail?.description?.length > 100 && !isShowMore
                        ? invoiceDetail?.description
                            .replaceAll(/\n/g, "<br>")
                            .substring(0, 100) + "..."
                        : invoiceDetail?.description.replaceAll(/\n/g, "<br>"),
                  }}
                ></div>
              )}
              <h1 className="font-poppins font-normal text-sm text-psp-nav text-justify">
                {/* {invoiceDetail?.description?.length > 100
                    ? isShowMore
                      ? invoiceDetail?.description
                      : invoiceDetail?.description?.substring(0, 100) + "..."
                    : invoiceDetail?.description} */}
                {invoiceDetail?.description?.length > 100 && (
                  <span
                    className="text-blue-600 underline cursor-pointer"
                    onClick={() => setIsShowMore(!isShowMore)}
                  >
                    {isShowMore ? t("INVOICE.showLess") : t("INVOICE.showMore")}
                  </span>
                )}
              </h1>
            </div>
          )}
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            {t("INVOICE.paymentData")}
          </h1>
          <div
            className={`grid grid-cols-2 gap-1 ${
              user?.name === invoiceDetail?.callerName ? "hidden" : ""
            }`}
          >
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.parentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
              <div className="grow text-right">{user?.name}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.studentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
              <div className="font-poppins grow text-right">
                {invoiceDetail?.callerName}
              </div>
            </div>
          </div>
          <div>
            <h1 className="font-poppins font-medium text-sm text-black my-2">
              {t("INVOICE.detailInvoice")}
            </h1>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceName")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
                <div className="grow text-right">{invoiceDetail?.title}</div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.date")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(invoiceDetail?.invoiceDate).format("LL")}
                </div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.limit")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(invoiceDetail?.dueDate).format("LL")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceType")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetail?.partialMethod == false
                    ? t("INVOICE.cash")
                    : t("INVOICE.credit")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  Status
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetail?.status == "UNPAID"
                    ? t("INVOICE.unpaid")
                    : invoiceDetail?.status == "PAID"
                      ? t("INVOICE.paid")
                      : t("INVOICE.partial")}
                </div>
              </div>
            </div>
            <div hidden={!invoiceDetail?.showDetail}>
              {invoiceDetail?.detail?.map((res: any) => (
                <div className="grid grid-cols-2 gap-1">
                  <div className="flex flex-row">
                    <h1 className="font-poppins font-normal text-sm text-psp-nav">
                      {res.title}
                    </h1>
                  </div>
                  <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                    <div className="grow text-right">
                      {formatCurrency(res.amount)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr />
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.amount")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(invoiceDetail?.amount)}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.paid")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-yellow-400 text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(invoiceDetail?.paidAmount)}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.minus")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-rose-600 text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  invoiceDetail?.amount - invoiceDetail?.paidAmount,
                )}
              </div>
            </div>
          </div>
          <div
            hidden={!invoiceDetail.partialMethod}
            className="flex flex-col gap-1 mb-2"
          >
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.inputAmount")}
              </h1>
            </div>

            <CurrencyInput
              className="px-3 rounded-xl h-10 border-1 border-psp-border-gray border-solid active:border-0"
              placeholder={placeholder}
              decimalsLimit={2}
              prefix={"Rp "}
              value={
                invoiceDetail?.amount - invoiceDetail?.paidAmount <= 10000
                  ? invoiceDetail?.amount - invoiceDetail?.paidAmount
                  : undefined
              }
              disabled={
                invoiceDetail?.amount - invoiceDetail?.paidAmount <= 10000
              }
              onValueChange={(value, name) => {
                setAmount(value || "");
                value == undefined ? setIsActive(true) : setIsActive(false);
              }}
            />
          </div>
        </div>
      </BottomSheet>
      {/* invoice payment success invoice */}

      <BottomSheet
        open={openPaymentSuccessInvoice}
        onDismiss={onDismissPaymentSuccessInvoice}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.8,
        ]}
        header={""}
        footer={
          <div className="flex flex-col gap-2 z-[1000]">
            {/* <button className="disabled:bg-psp-gray w-full bg-white shadow-lg  text-psp-primary  border-1 border-psp-primary border-solid py-2.5 text-sm font-semibold rounded-lg">
              {t("INVOICE.share")}
            </button> */}
            <button
              onClick={onClick}
              style={{ backgroundColor: customApp?.app_accent_color }}
              className={`disabled:bg-psp-gray w-full  shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp?.app_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("INVOICE.download")}
            </button>
            <button
              onClick={() => onDismissPaymentSuccessInvoice()}
              style={{ backgroundColor: customApp?.app_secondary_accent_color }}
              className={`disabled:bg-psp-gray w-full shadow-lg py-2.5 text-sm font-semibold rounded-lg ${
                isDarkColor(customApp?.app_secondary_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("OTHER.close")}
            </button>
          </div>
        }
      >
        {invoiceDetail?.description != "" && showDescription && (
          <div>
            {invoiceDetail?.description && (
              <div
                className="font-poppins font-normal text-sm text-psp-nav text-justify"
                dangerouslySetInnerHTML={{
                  __html:
                    invoiceDetail?.description?.length > 100 && !isShowMore
                      ? invoiceDetail?.description
                          .replaceAll(/\n/g, "<br>")
                          .substring(0, 100) + "..."
                      : invoiceDetail?.description.replaceAll(/\n/g, "<br>"),
                }}
              ></div>
            )}
            <h1 className="font-poppins font-normal text-sm text-psp-nav text-justify">
              {/* {invoiceDetail?.description?.length > 100
                  ? isShowMore
                    ? invoiceDetail?.description
                    : invoiceDetail?.description?.substring(0, 100) + "..."
                  : invoiceDetail?.description} */}
              {invoiceDetail?.description?.length > 100 && (
                <span
                  className="text-blue-600 underline cursor-pointer"
                  onClick={() => setIsShowMore(!isShowMore)}
                >
                  {isShowMore ? t("INVOICE.showLess") : t("INVOICE.showMore")}
                </span>
              )}
            </h1>
          </div>
        )}
        <div className="px-4 py-2 bg-white" ref={ref}>
          <div className="flex flex-col items-center gap-1 mb-6">
            <img className="w-24 h-24 mb-1" src={paymentSuccess} alt="" />
            <h1 className="m-0 font-montserrat text-2xl font-medium">
              {t("INVOICE.success")}
            </h1>
            <span className="font-montserrat text-sm text-psp-nav font-light">
              {t("INVOICE.date")} :{" "}
              {moment(detailPaymentSuccess.dateTime).format("LLL")}
            </span>
          </div>
          <h1 className="font-poppins font-medium text-sm text-black my-2">
            {t("INVOICE.paymentData")}
          </h1>
          <div
            className={`grid grid-cols-2 gap-1 ${
              user?.name === invoiceDetail?.callerName ? "hidden" : ""
            }`}
          >
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.parentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
              <div className="grow text-right">{user?.name}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.studentName")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
              <div className="font-poppins grow text-right">
                {invoiceDetail?.callerName}
              </div>
            </div>
          </div>
          <div>
            <h1 className="font-poppins font-medium text-sm text-black my-2">
              {t("INVOICE.detailInvoice")}
            </h1>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceName")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2">
                <div className="grow text-right">{invoiceDetail?.title}</div>
              </div>
            </div>
            <div className="font-poppins grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className=" font-normal text-sm text-psp-nav">
                  {t("INVOICE.payDate")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {moment(detailPaymentSuccess.dateTime).format("LL")}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  {t("INVOICE.invoiceType")}
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-nav text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetail?.partialMethod == false
                    ? t("INVOICE.cash")
                    : t("INVOICE.credit")}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-1">
              <div className="flex flex-row">
                <h1 className="font-poppins font-normal text-sm text-psp-nav">
                  Status
                </h1>
              </div>
              <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                <div className="grow text-right">
                  {invoiceDetail?.status == "UNPAID"
                    ? t("INVOICE.unpaid")
                    : invoiceDetail?.status == "PAID"
                      ? t("INVOICE.paid")
                      : detailPaymentSuccess?.inquiryResponseDto?.amount -
                            (detailPaymentSuccess?.inquiryResponseDto
                              ?.paidAmount +
                              detailPaymentSuccess?.amount) ==
                          0
                        ? t("INVOICE.paid")
                        : t("INVOICE.partial")}
                </div>
              </div>
            </div>
            <div hidden={!invoiceDetail?.showDetail}>
              {invoiceDetail?.detail?.map((res: any) => (
                <div className="grid grid-cols-2 gap-1">
                  <div className="flex flex-row">
                    <h1 className="font-poppins font-normal text-sm text-psp-nav">
                      {res.title}
                    </h1>
                  </div>
                  <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
                    <div className="grow text-right">
                      {formatCurrency(res.amount)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr />
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.total")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  detailPaymentSuccess?.inquiryResponseDto?.amount,
                )}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.totalpay")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-psp-hover text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(detailPaymentSuccess?.amount)}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-1">
            <div className="flex flex-row">
              <h1 className="font-poppins font-normal text-sm text-psp-nav">
                {t("INVOICE.minus")}
              </h1>
            </div>
            <div className="font-poppins font-normal text-sm text-rose-600 text-left flex flex-row gap-2 w-full">
              <div className="grow text-right">
                {formatCurrency(
                  detailPaymentSuccess?.inquiryResponseDto?.amount -
                    (detailPaymentSuccess?.inquiryResponseDto?.paidAmount +
                      detailPaymentSuccess?.amount),
                )}
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center gap-2 mb-3">
            {/* <div className="flex flex-row gap-2 justify-center">
              <FacebookShareButton
                ref={shareButton}
                openShareDialogOnClick={url !== "none"}
                url={"https://teknologikartu.com"}
                onClick={onClick}
              >
                <FacebookIcon size={32} round={true} />
              </FacebookShareButton>
              <WhatsappShareButton
                ref={shareButton}
                openShareDialogOnClick={url !== "none"}
                url={url}
                onClick={onClick}
              >
                <WhatsappIcon size={32} round={true} />
              </WhatsappShareButton>
              <TelegramShareButton
                ref={shareButton}
                openShareDialogOnClick={url !== "none"}
                url={url}
                onClick={onClick}
              >
                <TelegramIcon size={32} round={true} />
              </TelegramShareButton>
            </div> */}
          </div>
        </div>
      </BottomSheet>

      <BottomSheet
        open={openFilter}
        onDismiss={onDismissFilter}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.8,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm font-bold text-black">
            {t("INVOICE.filter")}
          </h1>
        }
        footer={""}
      >
        <div className="p-4">
          <div className="mb-4">
            <p className="mb-3 text-sm font-semibold text-black">
              {t("INVOICE.tags")}
            </p>
            <div data-body-scroll-lock-ignore>
              <Select
                options={tagSelectOptions}
                isClearable
                menuPosition="absolute"
                menuPlacement="auto"
                maxMenuHeight={240}
                value={
                  tagSelectOptions.find(
                    (option) => option.value === draftTags[0],
                  ) ?? null
                }
                onChange={(selectedOption: any) =>
                  setDraftTags(
                    selectedOption?.value ? [selectedOption.value] : [],
                  )
                }
                placeholder={t("INVOICE.selectTag")}
                className="text-sm"
                styles={tagSelectStyles}
              />
            </div>
          </div>
          <div className="mb-6">
            <p className="font-semibold text-base mb-3">
              {t("INVOICE.invoiceName")}
            </p>
            <input
              type="text"
              value={filterInvoiceName}
              onChange={(e) => setFilterInvoiceName(e.target.value)}
              className="px-3 grow rounded-lg w-full h-10 border-1 border-psp-gray border-solid disabled:text-psp-nav active:border-psp-gray focus:border-psp-gray active:ring-0 focus:ring-0"
            />
          </div>
          {callerIdentities.length !== 1 && (
            <div className="mb-6">
              <label
                htmlFor="invoice-mobile-student-filter"
                className="mb-3 block text-sm font-semibold text-black"
              >
                {t("INVOICE.studentName")}
              </label>
              <select
                id="invoice-mobile-student-filter"
                value={draftStudentId}
                onChange={(event) => setDraftStudentId(event.target.value)}
                className="w-full rounded-xl border bg-white border-slate-300 px-4 py-3 text-sm"
              >
                <option value="">{t("INVOICE.allStudents")}</option>
                {callerIdentities.map((identity: any) => {
                  const identityValue =
                    identity?.id ?? identity?.callerId ?? "";

                  return (
                    <option key={identityValue} value={String(identityValue)}>
                      {identity?.name ?? identity?.callerId}
                    </option>
                  );
                })}
              </select>
            </div>
          )}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={resetFilters}
              className="w-full rounded-xl border border-slate-300 px-4 py-3 text-sm font-semibold text-slate-600"
            >
              {t("OTHER.reset")}
            </button>
            <button
              type="button"
              onClick={applyFilters}
              style={{ backgroundColor: customApp?.app_accent_color }}
              className={`w-full rounded-xl px-4 py-3 text-sm font-semibold ${
                isDarkColor(customApp?.app_accent_color)
                  ? "text-white"
                  : "text-black"
              }`}
            >
              {t("OTHER.apply")}
            </button>
          </div>
        </div>
      </BottomSheet>

      {/* sorting */}
      <BottomSheet
        open={openSorting}
        onDismiss={onDismissSorting}
        defaultSnap={({ snapPoints, lastSnap }) =>
          lastSnap ?? Math.min(...snapPoints)
        }
        snapPoints={({ maxHeight }) => [
          maxHeight - maxHeight / 5,
          maxHeight * 0.8,
        ]}
        header={
          <h1 className="font-poppins flex items-left text-sm  font-bold text-black">
            {t("INVOICE.sort")}
          </h1>
        }
        footer={""}
      >
        <div className="p-4">
          <div className="flex flex-column gap-2">
            {sortingOptions.map((sort) => (
              <div className="p-4 border-b border-b-silver flex justify-between">
                <label htmlFor={sort.value}>{sort.label}</label>
                <input
                  onChange={(e) => handleSortChange(e)}
                  id={sort.value}
                  name="selectSortBy"
                  checked={sortBy === sort.value}
                  className="w-5 h-5 border-2 border-psp-primary rounded-full"
                  style={{ accentColor: customApp?.app_accent_color }}
                  type="radio"
                  value={sort.value}
                />
              </div>
            ))}
          </div>
        </div>
      </BottomSheet>

      <Tab.Group
        selectedIndex={activeTab}
        onChange={(index) => {
          console.log("Changed selected tab to:", index);
          setActiveTab(index);
        }}
      >
        <Tab.List className="flex space-x-1  bg-white p-1  sticky top-24 ">
          {Object.keys(categories).map((category, key) => (
            <Tab
              key={category}
              style={{
                background: activeTab == key ? customApp?.app_accent_color : "",
                color: activeTab == key ? customApp?.app_accent_color : "#fff",
              }}
              className={({ selected }) =>
                classNames(
                  "w-full py-2.5 text-sm font-medium",
                  " ",
                  selected
                    ? `font-montserrat rounded-xl text-sm font-semibold ${
                        isDarkColor(customApp?.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`
                    : "text-black bg-none font-montserrat text-sm font-semibold",
                )
              }
            >
              {category}
            </Tab>
          ))}
        </Tab.List>

        {/* invoice */}
        <Tab.Panels>
          {/* data invoice */}
          <Tab.Panel className="p-4 top-to-bottom">
            <div className="flex flex gap-3">
              <button
                onClick={openSortingMenu}
                className={`px-3 py-2.5 bg-white rounded-full font-bold text-dark text-xs flex gap-6 items-center`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z"
                    clipRule="evenodd"
                  />
                </svg>

                {t("INVOICE.sort")}

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m19.5 8.25-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </button>
              <button
                onClick={openFilterMenu}
                className={`px-3 py-2.5 bg-white text-dark rounded-full font-bold text-xs flex gap-6 items-center`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-4"
                >
                  <path
                    fillRule="evenodd"
                    d="M3 5.25A2.25 2.25 0 0 1 5.25 3h13.5A2.25 2.25 0 0 1 21 5.25v.44a2.25 2.25 0 0 1-.659 1.591l-4.922 4.922a2.25 2.25 0 0 0-.659 1.591v3.152a2.25 2.25 0 0 1-1.006 1.874l-2.25 1.5A2.25 2.25 0 0 1 8 18.45v-4.652a2.25 2.25 0 0 0-.659-1.591L2.66 7.28A2.25 2.25 0 0 1 2 5.69v-.44Z"
                    clipRule="evenodd"
                  />
                </svg>
                Filter
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m19.5 8.25-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </button>
            </div>
            {invoices.map((res: any) => (
              <div className="bg-white rounded-xl shadow-md font-montserrat my-3">
                <div className="grid grid-row-2 divide-y ">
                  <div className=" pl-3 pt-3 pb-3">
                    <div className="flex flex-row items-center gap-2">
                      <img src={getIconInvoice(res)} className="flex-0" />

                      <h1 className="m-0 font-bold text-sm font-montserrat grow">
                        {res.title}
                      </h1>
                      {res.detail[0].discount > 0 ? (
                        <img src={discount} className="flex-0" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="p-3 pt-0">
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="font-montserrat m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.name")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {res.callerName}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.nis")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {res.callerId}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.date")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {moment(res.invoiceDate).format("LL")}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.limit")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {moment(res.dueDate).format("LL")}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.credit")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {" "}
                          {res.partialMethod == true
                            ? t("OTHER.yes")
                            : t("OTHER.no")}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.total")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {formatCurrency(res.amount)}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.paid")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {formatCurrency(res.paidAmount)}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center mt-3">
                      <div className="flex flex-col">
                        <h1 className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.sisa")}
                        </h1>
                        <p className="m-0 text-sm font-bold text-black">
                          {formatCurrency(res.amount - res.paidAmount)}
                        </p>
                      </div>
                      <button
                        onClick={() =>
                          navigate(`/invoicedetail/${res.invoiceId}`, {
                            state: { data: res },
                          })
                        }
                        style={{ backgroundColor: customApp?.app_accent_color }}
                        className={`px-2 py-2.5 rounded-lg font-bold text-xs active:bg-psp-active ${
                          isDarkColor(customApp?.app_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                      >
                        {t("INVOICE.pay")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {currentSizeInvoice < 10 ? (
              ""
            ) : (
              <div className="flex w-full">
                <button
                  onClick={addMoreInvoice}
                  style={{ background: customApp?.app_accent_color }}
                  className={`w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active ${
                    isDarkColor(customApp?.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {t("OTHER.showMore")}
                </button>
              </div>
            )}
          </Tab.Panel>

          {/* data history  */}
          <Tab.Panel className="p-4 top-to-bottom">
            {invoicePaid.map((res: any) => (
              <div className="bg-white rounded-xl shadow-md font-montserrat my-3">
                <div className="grid grid-row-2 divide-y ">
                  <div className=" pl-3 pt-3 pb-3">
                    <div className="flex flex-row items-center gap-2">
                      <img src={getIconInvoice(res)} className="flex-0" />
                      <h1 className="m-0 font-bold text-sm font-montserrat grow">
                        {res.title}
                      </h1>
                      {res.detail[0].discount > 0 ? (
                        <img src={discount} className="flex-0" />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="p-3 pt-0">
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.studentName")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {res.callerName}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.nis")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {res.callerId}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.date")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {moment(res.invoiceDate).format("LL")}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.limit")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {moment(res.dueDate).format("LL")}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.credit")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {res.partialMethod ? t("OTHER.yes") : t("OTHER.no")}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <p className="m-0 text-xs font-normal text-psp-nav">
                          {t("INVOICE.paid")}
                        </p>
                      </div>
                      <div className="col-span-2">
                        <span className="m-0 text-xs font-normal text-psp-nav">
                          {formatCurrency(res.paidAmount)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 items-center mt-3 divide-y p-3">
                    <div className="flex flex-col">
                      <h1 className="m-0 text-sm font-normal text-psp-nav">
                        {t("INVOICE.total")}
                      </h1>
                      <p className="m-0 text-sm font-bold text-black">
                        {formatCurrency(res.amount)}
                      </p>
                    </div>
                    <button
                      onClick={() => openSheetDetailHistory(res)}
                      style={{ backgroundColor: customApp?.app_accent_color }}
                      className={`px-2 py-2.5 rounded-lg font-bold text-xs ${
                        isDarkColor(customApp?.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                    >
                      Detail
                    </button>
                  </div>
                </div>
              </div>
            ))}
            {currentSizeInvoicePaid < 10 ? (
              ""
            ) : (
              <div className="flex w-full">
                <button
                  onClick={addMoreInvoicePaid}
                  style={{ background: customApp?.app_accent_color }}
                  className={`w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active ${
                    isDarkColor(customApp?.app_accent_color)
                      ? "text-white"
                      : "text-black"
                  }`}
                >
                  {t("OTHER.showMore")}
                </button>
              </div>
            )}
          </Tab.Panel>
          <Tab.Panel className="top-to-bottom">
            <div className="bg-white w-full px-4 pt-4">
              <table className="table-auto border-spacing-y-5 border-spacing-x-2 w-full">
                <thead
                  className="border-collapse"
                  style={{
                    backgroundColor: customApp?.app_accent_color,
                    color: isDarkColor(customApp?.app_accent_color)
                      ? "white"
                      : "black",
                  }}
                >
                  <tr>
                    <th className="text-xs text-center font-medium px-2 py-1">
                      {t("INVOICE.title")}
                    </th>
                    <th className="text-xs text-center font-medium px-2 py-1">
                      {t("INVOICE.amount")}
                    </th>
                    <th className="text-xs text-center font-medium px-2 py-1">
                      {t("INVOICE.paid")}
                    </th>
                    <th className="text-xs text-center font-medium px-2 py-1">
                      {t("INVOICE.totalDue")}
                    </th>
                  </tr>
                </thead>
                <tbody className="mt-3 border-spacing-x-2">
                  {invoiceSummary.map((res: any, index: any) => (
                    <tr className="">
                      <td className="text-xs text-black font-light">
                        <div className="flex flex-col my-1 px-1">
                          <h1
                            className="font-montserrat font-medium m-0 "
                            style={{ fontSize: 10 }}
                          >
                            {res.title}
                          </h1>
                          <span
                            style={{ fontSize: 9 }}
                            className="font-montserrat text-xs font-medium text-psp-nav "
                          >
                            {moment(res.invoiceDate)
                              .locale(i18n.language)
                              .format("LL")}
                          </span>
                        </div>
                      </td>
                      <td className="font-montserrat text-xs text-blue-700 font-medium text-right px-1">
                        {numberWithCommas(res.amount)}
                      </td>
                      <td className="font-montserrat text-xs text-emerald-500 font-medium text-right px-1">
                        {numberWithCommas(res.paidAmount)}
                        {/* {formatCurrency(res.paidAmount).replace(",00", "")} */}
                      </td>
                      <td className="font-montserrat text-xs text-rose-600 font-medium text-right px-1">
                        {numberWithCommas(res.amount - res.paidAmount)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {currentSizeInvoice < 10 ? (
              ""
            ) : (
              <div className="flex flex-row w-full justify-center mt-3">
                <div className=" bg-white items-center shadow-md flex rounded-full overflow-hidden">
                  <button
                    disabled={page == 0}
                    onClick={() => addMoreInvoiceSummary("prev")}
                    style={{ color: customApp?.app_accent_color }}
                    className="disabled:bg-neutral-200 disabled:text-psp-nav bg-white  rounded-r-xl py-1 px-3 font-montserrat font-medium text-lg  active:text-psp-active"
                  >
                    {"<"}
                  </button>
                  <span className="font-montserrat font-medium text-xs">
                    1/3
                  </span>
                  <button
                    onClick={() => addMoreInvoiceSummary("next")}
                    disabled={currentSizeInvoiceSummary < 10}
                    style={{ color: customApp?.app_accent_color }}
                    className="disabled:bg-neutral-200 disabled:text-psp-nav bg-white rounded-sm px-3 py-1 font-montserrat font-medium text-lg active:text-psp-active"
                  >
                    {">"}
                  </button>
                </div>
              </div>
            )}
            {/* <div className="flex flex-row w-full justify-center">
              <button
                onClick={download}
                style={{ backgroundColor: customApp?.app_accent_color }}
                className=" mt-3 text-white font-bold w-10/12 items-center py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
              >
                {t("INVOICE.download")}
              </button>
            </div> */}
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default ComponentInvoice;
